<template>
    <div id="file-container">
        <v-btn
            v-if="fileUrlData"
            :loading="isLoading"
            :disabled="isLoading"
            style="margin-bottom: 20px; background-color: #009688; color: white;"
            @click="fetchFile"
        >
            <v-icon>{{ mdiDownload }}</v-icon>DOWNLOAD AUTHORIZATION SLIP
        </v-btn>

        <p v-if="error" class="error--text">
            {{ error }}
        </p>
    </div>
</template>

<script>
import { mdiDownload } from '@mdi/js'
import { saveAs } from 'file-saver'
import { base64ToBlob } from '../../../utils/helpers'

export default {
    props: ['pdfData'],
    data: () => ({
        mdiDownload,
        isLoading: false,
        error: null,
        fileUrlData: null
    }),
    watch: {
        pdfData: {
            immediate: true,
            handler(newVal) {
                this.fileUrlData = newVal
            }
        }
    },
    methods: {
        fetchFile() {
            this.isLoading = true
            this.error = null
            try {
                const { url, type, fileName } = this.fileUrlData
                const blob = base64ToBlob(url, type)
                saveAs(blob, `${fileName}.pdf`)
            } catch (error) {
                this.error = 'Something went wrong: ' + error.message
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>
